var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, customElement, property, css, state } from 'lit-element';
import moment from 'moment';
import { InfoPointPopupfileView } from './infopoint-filepopupview';
import { getFileType, getPlaceholder } from './utils';
export class InfoPointTemplateWrap {
    async createView() {
        return document.createElement('infopoint-template');
    }
}
export class InfoPointTemplateBottomWrap {
    async createView() {
        const elem = document.createElement('infopoint-template');
        elem.flexFlow = 'column-reverse';
        return elem;
    }
}
let InfoPointTemplate = class InfoPointTemplate extends LitElement {
    constructor() {
        super();
        this.path = '/';
        this.switchIcon = "/assets/default-icon.png";
        this.currentViewName = "default";
        this.allFiles = [];
        this.searchResults = [];
        this.searchText = "";
        this.breadCrumbs = [];
        this.views = {};
        this.templateName = "";
        this.isSearchEnabled = false;
        this.currentTime = moment().format('HH:mm');
        setInterval(() => {
            this.currentTime = moment().format('HH:mm');
        }, 5000);
    }
    connectedCallback() {
        super.connectedCallback();
        this.vfs = this.application.vfs();
        this.style.flexFlow = this.flexFlow || 'column';
        const pathParts = window.location.pathname.match(/[^/]+/g) || [];
        if (pathParts.length > 1) {
            let pathname = location.pathname.endsWith('/') ? location.pathname.slice(0, -1) : location.pathname;
            pathname = `${pathname}/${pathParts[1]}`;
            this.vfs.stat(pathname).then((f) => {
                var _a;
                this.templateName = ((_a = f.xAttr) === null || _a === void 0 ? void 0 : _a.name) || f.name;
            });
            this.vfs.readDir(`/search/`).then(async (files) => {
                var _a;
                this.filePopup = await new InfoPointPopupfileView().createView();
                this.filePopup.style.position = "";
                this.filePopup.style.width = "0";
                this.filePopup.style.height = "0";
                this.filePopup.setNavigator(this.navigator);
                this.filePopup.setVFS(this.vfs);
                this.filePopup.setAnalytics(this.application.analytics());
                (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.appendChild(this.filePopup);
                this.allFiles = files;
            });
            this.updateBreadcrumbs();
        }
    }
    setContent(elem) {
        elem.slot = 'content-slot';
        // Musi se pouzivat this, protoze kdyby se pouzilo this.shadowRoot, tak se to vloží pod shadowRoot,
        // ale pro správné fungování slotů je potřeba aby to bylo na stejné úrovni jako je shadowRoot
        this.appendChild(elem);
    }
    async goHome() {
        this.clearSearch();
        this.navigator.goHome();
    }
    goBack() {
        var _a;
        this.clearSearch();
        (_a = this.navigator) === null || _a === void 0 ? void 0 : _a.goBack();
    }
    getPath(name) {
        const path = this.path.slice(0, this.path.indexOf(name) + name.length + 1);
        if (path[path.length - 1] === '/') {
            return path.slice(0, -1);
        }
        return path;
    }
    updateBreadcrumbs() {
        if (this.path.startsWith("/search/")) {
            const regex = /search\/([^\/]+).+/;
            let m = regex.exec(this.path);
            if (!m) {
                throw Error("unable to search");
            }
            m.filter((match, groupIndex) => {
                return groupIndex === 1;
            });
            let searchItem = m.find((s, idx) => idx === 1) || "";
            this.breadCrumbs = [html `<div style="padding-left: .5rem; padding-right: .5rem; font-size: 2.5rem;">/</div><div style="color: #2AB1B5; font-size: 2.5rem;">${searchItem}</div>`];
        }
        else {
            Promise.all(this.path.split('/').filter((v) => v !== '').map(async (name, idx) => {
                var _a;
                const file = await this.vfs.stat(this.getPath(name));
                const displayName = ((_a = file.xAttr) === null || _a === void 0 ? void 0 : _a.name) || file.name;
                return html `
          ${idx !== 0 ? html `<div style="padding-left: .5rem; padding-right: .5rem; font-size: 2.5rem;">/</div>` : ``}
          <div @click=${() => this.navigator.push(this.getPath(name))} style="${idx === 0 ? `padding-left: .5rem;` : ``} color: #2AB1B5; font-size: 2.5rem;">${displayName}</div>`;
            })).then((breadCrumbs) => {
                this.breadCrumbs = breadCrumbs;
            });
        }
        this.views = this.application.views(this.path);
    }
    updated(changedProperties) {
        if (changedProperties.has("path")) {
            this.updateBreadcrumbs();
        }
    }
    async switchLayout() {
        const viewNames = Object.keys(this.views);
        let idx = viewNames.findIndex((v) => v === this.currentViewName);
        idx += 1;
        if (idx === viewNames.length) {
            idx = 0;
        }
        this.currentViewName = viewNames[idx];
        this.switchIcon = `/assets/${this.currentViewName}-icon.png`;
        this.dispatchEvent(new CustomEvent("viewchanged", {
            detail: {
                viewName: this.currentViewName
            }
        }));
    }
    clearSearch() {
        var _a;
        this.searchResults = [];
        this.searchText = "";
        const s = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById("search");
        s.value = "";
    }
    searchClick(e) {
        var _a;
        const searchInput = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById("search");
        if (!searchInput) {
            return;
        }
        if (!this.isSearchEnabled) {
            return;
        }
        this.navigator.push(`/search/${encodeURIComponent(searchInput.value)}/`);
        this.clearSearch();
    }
    filterFiles() {
        this.searchText = this.searchText.toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        this.searchResults = this.allFiles.filter((f) => { var _a; return f.name.toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(this.searchText) || ((_a = f.xAttr) === null || _a === void 0 ? void 0 : _a.name.toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(this.searchText)); }).map((f) => {
            var _a, _b, _c, _d, _e;
            let buttonClickCallback = () => {
                this.clearSearch();
                return this.navigator.push(f.name);
            };
            // TODO: FIXME: file.contentType === "application/x-kiwi-kiosk-1"
            if (!f.isDir || f.contentType === "application/x-kiwi-kiosk-1") {
                buttonClickCallback = () => {
                    this.filePopup.filesInFolder = [f];
                    return this.filePopup.showFilePopup(f);
                };
            }
            const buttonName = `${((_a = f.xAttr) === null || _a === void 0 ? void 0 : _a.name) || f.name} ${!f.isDir ? '' : (((_b = f.xAttr) === null || _b === void 0 ? void 0 : _b.filesCount) || 0) > 0 ? `(${(_c = f.xAttr) === null || _c === void 0 ? void 0 : _c.filesCount})` : ''}`;
            // TODO: FIXME: file.contentType === "application/x-kiwi-kiosk-1"
            const thumbnails = f.isDir && f.contentType !== "application/x-kiwi-kiosk-1" ? (((_d = f.xAttr) === null || _d === void 0 ? void 0 : _d.thumbnailUrls) || []) : [((_e = f.xAttr) === null || _e === void 0 ? void 0 : _e.thumbnailUrl) || getPlaceholder(f)];
            return html `
      <div class="button-detail" @click=${buttonClickCallback}>
          <div class="thumbnail-wrapper">
              <rotate-img .urls="${thumbnails}"></rotate-img>
          </div>
          <div class="detail">
              <div>
                  <div style="font-size: 2rem;">${buttonName}</div>
                  <div style="font-size: 1.4rem;">Type: ${getFileType(f)}</div>
              </div>
          </div>
      </div>`;
        });
    }
    render() {
        return html `
    <div class="header-wrapper">
      <div class="header-left">
        <div class="back-button" @click="${this.goBack}">
          <img draggable="false" src="/assets/back.png"/>
        </div>
        <div class="home-button" @click="${this.goHome}">
          <img draggable="false" src="/assets/home.png"/>
        </div>
        <div class="breadcrumbs-wrapper">
        ${this.templateName ? html `
          ${this.breadCrumbs}
        ` : html ``}
        </div>
      </div>

      <div class="header-right">
        <form id="searchForm" class="search-input" @submit="${(e) => {
            e.preventDefault();
            this.searchClick(e);
            return false;
        }}" style="position: relative;">
          <input autocomplete="off" type="text" id="search" name="search" placeholder="Search" @input="${(e) => {
            var _a;
            const searchInput = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById("search");
            if (!searchInput) {
                return;
            }
            this.isSearchEnabled = searchInput.value !== "";
            this.searchText = searchInput.value;
            this.filterFiles();
        }}">
          <input class="search-button" type="image" style="${!this.isSearchEnabled ? "-webkit-filter: grayscale(1); filter: grayscale(1); opacity: 0.5;" : ""}" src="/assets/search.png" alt="Submit" width="48" height="48">
          ${this.searchText && this.searchResults.length > 0 ? html `
          <div class="search-autocomplete"> 
              ${this.searchResults}
          </div>
          <div class="search-close-background" @click="${() => this.clearSearch()}"></div>
          ` : ``}
        </form>
        <div class="company-name">
          <img draggable="false" src="/assets/logo.png">
          <div>Ki-Wi Digital</div>
        </div>
        <div class="clock">${this.currentTime}</div>
      </div>
    </div>

    <div class="slot">
      <slot name='content-slot'></slot>
    </div>

    <div class="footer-wrapper">
      <div class="scroll-text-header">
        <div>NEWS</div>
      </div>
      <div class="scroll-text-wrapper">
        <div id="scroll-text">The State Department has stopped using online booking because third-party bots were making last-minute appointments and selling them to travelers. Now, they can be scheduled only by phone    |    Three neighborhoods offer art, great food (and drinks), river breezes and lush green space — not to mention amazing views. And, for now, there’s still plenty of elbow room    |    On the island of Sumatra, a devoted group of conservationists is grasping for a solution that will benefit both the animals and the people who live around them</div>
      </div>
    </div>

    ${Object.keys(this.views).length > 1 ?
            html `
        <div class="toggleView" @click="${(e) => this.switchLayout()}" style="position: absolute; right: 0; bottom: 9%; padding: 2rem;">
          <div>
            <img src="${this.switchIcon}">
          </div>
        </div>` : ``}
    `;
    }
};
InfoPointTemplate.styles = css `
    :host {
      box-sizing: border-box;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      background-color: #E2F3F3;
    }

    .header {
      display: flex;
      flex-flow: row;
      justify-content: center;
      flex: 100;
  }

  .slot {
    box-sizing: border-box;
    width: 100%;
    height: 80%;
    border: 1rem solid #E2F3F3;
  }
  .header {
    font-size: 2rem;
    width: 100%;
    background-color: rgba(255,255,255,0.8);
    text-align: center;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }


  #scroll-text {
    /* animation properties */
    transform: translateX(17%);
    animation: my-animation 80s linear infinite;
    padding: 1rem;
    white-space: nowrap;
  }
  
  @keyframes my-animation {
    from {
      transform: translateX(17%);
    }
    to {
      transform: translateX(-100%);
    }
  }

    .clock {
      color: #fff;
      background-color: #2AB1B5;
      font-size: 2rem;
      padding: 1rem;
      margin: 0.8rem;
    }

    .company-name {
      display: flex;
      flex-flow: row;
      font-size: 2rem;
      color: #545454;
      align-items: center;
      font-weight: bold;
    }

    .search-input {
      display: flex;
      flex-flow: row;
      font-size: 3rem;
      color: #545454;
      align-items: center;
      padding: 1rem;
      padding-right: 2rem;
    }

    .search-input img {
      width: 3rem;
    }

    .search-input input[type="text"] {
      font-size: 1.2rem;
      width: 13rem;
      padding:10px;
      border:0;
      border-radius:10px;
      margin-right: 1rem;

      transition: all 0.30s ease-in-out;
      outline: none;
      border: 2px solid #DDDDDD;
    }
     
    input[type=text]:focus, textarea:focus {
      box-shadow: 0 0 10px #2AB1B5;
      border: 2px solid #2AB1B5;
    }

    .company-name img {
      width: 3rem;
      margin-right: 1rem;
    }

    .header-right {
      flex: 1;
      display: flex;
      flex-flow: row;
      justify-content: flex-end;
      align-items: center;
    }

    .header-left {
      flex: 1;
      display: flex;
      flex-flow: row;
      justify-content: flex-start;
      align-items: center;
    }

    .home-button {
      padding: 1rem;
      padding-right: 0.2rem;
    }

    .button-opacity {
      opacity: 0.5;
    }

    .home-button img,
    .back-button img {
      width: 3rem;
    }

    .back-button {
      padding: 1rem;
    }

    .breadcrumbs-wrapper {
      line-height: 2.8rem;
      font-weight: bold;
      display: flex;
      flex-flow: row;
      align-items: center;
    }

    .breadcrumbs {
      font-size: 2.5rem;
      font-weight: bold;
      display: flex;
      flex-flow: row;
      align-items: center;
      padding-left: 1rem;
      color: #2AB1B5
    }

    .header-wrapper {
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      background-color: #fff;
      width: 100%;
    }

    .footer-wrapper {
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      background-color: #fff;
      width: 100%;
      border-left: 2rem solid #E2F3F3;
      border-bottom: 2rem solid #E2F3F3;
      border-right: 2rem solid #E2F3F3;
      box-sizing: border-box;
    }

    .scroll-text-wrapper {
      margin-left: 1rem;
      margin-right: 1rem;
      flex: 1;
      display: flex;
      flex-flow: row;
      justify-content: flex-start;
      align-items: center;
      background-color: #fff;
      color: #3BB8B9;
      font-size: 2rem;
      overflow: hidden;
    }

    .scroll-text-header {
      display: flex;
      flex-flow: row;
      justify-content: flex-start;
      align-items: center;
      background-color: #2AB1B5;
      color: #fff;
    }

    .scroll-text-header div {
      padding: 1rem;
      font-size: 2rem;
    }

    .search-button:active,
    .back-button:active,
    .home-button:active,
    .toggleView:active {
      opacity: 0.5;
    }

    .button-detail {
      display: flex;
      flex-flow: row;
      align-items: center;
      font-size: 2rem;
      text-align: center;
      margin-right: 1rem;
      background-color: #fff;
      height: 7rem;
      padding-left: 1rem;
      padding-right: 1rem;
    }

    .button-detail:nth-child(even) {
      background-color: rgba(226, 243, 243, 0.5)
    }

    .thumbnail-wrapper {
      flex: 1;
      height: 80%;
      background-image: url(/assets/spinner.gif);
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 50%;
    }

    .detail {
      flex: 7;
      display: flex;
      flex-flow: row;
      margin-left: 1rem;
      text-align: left;
      justify-content: space-between;
      align-items: center;
    }

    .search-autocomplete {
      position: absolute;
      top: 110%;
      z-index: 2;
      max-height: 900%;
      overflow-y: auto;
      width: 43.5rem;
      background-color: #fff;
      border: 2px solid rgb(221, 221, 221);
      padding: 10px;
      border-radius: 10px;
    }

    .search-close-background {
      position: absolute;
      height: 1233%;
      width: 600%;
      opacity: 0;
      top: 110%;
      left: -350%;
      z-index: 1;
    }
  `;
__decorate([
    property()
], InfoPointTemplate.prototype, "navigator", void 0);
__decorate([
    property()
], InfoPointTemplate.prototype, "flexFlow", void 0);
__decorate([
    property()
], InfoPointTemplate.prototype, "application", void 0);
__decorate([
    property()
], InfoPointTemplate.prototype, "homeUrl", void 0);
__decorate([
    property()
], InfoPointTemplate.prototype, "path", void 0);
__decorate([
    state()
], InfoPointTemplate.prototype, "switchIcon", void 0);
__decorate([
    state()
], InfoPointTemplate.prototype, "currentViewName", void 0);
__decorate([
    state()
], InfoPointTemplate.prototype, "searchResults", void 0);
__decorate([
    state()
], InfoPointTemplate.prototype, "searchText", void 0);
__decorate([
    state()
], InfoPointTemplate.prototype, "currentTime", void 0);
__decorate([
    state()
], InfoPointTemplate.prototype, "breadCrumbs", void 0);
__decorate([
    state()
], InfoPointTemplate.prototype, "views", void 0);
__decorate([
    state()
], InfoPointTemplate.prototype, "templateName", void 0);
__decorate([
    state()
], InfoPointTemplate.prototype, "isSearchEnabled", void 0);
InfoPointTemplate = __decorate([
    customElement('infopoint-template')
], InfoPointTemplate);
export { InfoPointTemplate };
//# sourceMappingURL=infopoint-template.js.map